// source: types/v1/question_option.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.types.v1.QuestionOption', null, global);
/**
 * @enum {number}
 */
proto.types.v1.QuestionOption = {
  QUESTION_OPTION_UNSPECIFIED: 0,
  QUESTION_OPTION_CANCELED: -1,
  QUESTION_OPTION_A: 1,
  QUESTION_OPTION_B: 2,
  QUESTION_OPTION_C: 3,
  QUESTION_OPTION_D: 4,
  QUESTION_OPTION_E: 5
};

goog.object.extend(exports, proto.types.v1);
